export type CmsShellViewerMode = 'live' | 'guest' | 'authenticated';

export const CMS_SHELL_PREVIEW_AUTHENTICATED_CREDITS = 1280;
